<template>
	<div class="bf">
		<div class="top pos flex flex_items pl20">
			<div id="">{{user.name}}</div>
			<div class="qd main_bg cf" @click="sign(0)" v-if="list.length != 0">去签到</div>
		</div>
		<div class="plr20">
			<div class="b_r_10 bgfff" style="overflow: hidden;">
				<div class="plr20 pt10 pb10" style="background-color: #FFCC66;">积分</div>
				<div class="flex flex_between flex_items plr20 pt20 pb20">
					<div class="">
						<div class="txt_center fw500 mb10">{{msg.total ? msg.total : 0}}</div>
						<div class="">总积分</div>
					</div>
					<div class="">
						<div class="txt_center fw500 mb10">{{msg.exchange ? msg.exchange : 0}}</div>
						<div class="">已冲销</div>
					</div>
					<div class="">
						<div class="txt_center fw500 mb10">{{msg.remain ? msg.remain : 0}}</div>
						<div class="">剩余积分</div>
					</div>
				</div>
			</div>
			<div class="plr20 bgfff mt20">
				<div class="flex flex_between flex_items" style="height: 70px;" @click="sign(3)">
					<div class="">
						<van-icon name="orders-o" class="mr20" />积分明细
					</div>
					<van-icon name="arrow" />
				</div>
        
				<div class="flex flex_between flex_items" v-if="list.length != 0" style="height: 70px;"
					@click="sign(2)">
					<div class="">
						<van-icon name="todo-list-o" class="mr20" />出勤记录
					</div>
					<van-icon name="arrow" />
				</div>
				<div class="flex flex_between flex_items" v-if="list.length != 0" style="height: 70px;"
					@click="sign(1)">
					<div class="">
						<van-icon name="records" class="mr20" />请假
					</div>
					<van-icon name="arrow" />
				</div>
        <div class="flex flex_between flex_items" style="height: 70px;" @click="show = true">
					<div class="">
						<van-icon name="edit" class="mr20" />修改密码
					</div>
					<van-icon name="arrow" />
				</div>
				<div class="flex flex_between flex_items" style="height: 70px;" @click="outlog">
					<div class="flex flex_items"><img class="mr20" src="@/assets/member/out.png"
							style="width: 18px;height: 18px;display: block;margin-left: 2px;">退出登录</div>
					<!-- <van-icon name="arrow" /> -->
				</div>
			</div>
		</div>
    <Popup v-model="show">
      <changeUserPassw @closeFn="show = false" @successFn="outlog"></changeUserPassw>
    </Popup>
		<div class="plr20 mt20 pb20" v-if="list.length == 1">
			<Calendar :markDate='unCheck' :markDateMore="havecheck" 
			:markDate1="leave" :markDate2="checking">
			</Calendar>
			<div class="pt20 mf c9 bgfff flex flex_items plr20 pb20 flex_between">
				<div class="">
					<span style="background: #3399FF;" class="circle"></span>待签到
				</div>
				<div class="">
					<span style="background: #00D8CC;" class="circle"></span>已签到
				</div>
				<div class="">
					<span style="background: rgb(255, 204, 102);" class="circle"></span>已请假
				</div>
				<div class="">
					<span style="background: #FE6F90;" class="circle"></span>未签到
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import Calendar from './calendar/calendar.vue';
  import { Popup } from "vant";
  import changeUserPassw from "@/components/changeUserPassw";
	// import Calendar from 'vue-calendar-component';
	export default {
		data() {
			return {
				user: {},
				msg: {},
				list: [],
				unCheck: [], //未签到
				checking: [], //待签到
				leave: [], //已请假
				havecheck: [], //已签到
				serArr:[],//未签到，已签到的时间戳
        show:false
			}
		},
		components: {
			Calendar,Popup,changeUserPassw
		},
		methods: {
			getMsg() {
				this.api.userScore().then(res => {
					this.msg = res.data
				})
			},
			outlog() {
				localStorage.removeItem('user')
				localStorage.removeItem('token')
				this.$router.push('/login')
			},
			//签到
			getList() {
				this.api.userPro().then(res => {
					this.list = res.data;
					if(this.list.length == 1){
						this.getsign(this.list[0].id);
					}
				})
			},
			//获取出勤记录
			getsign(id){
				let leaveArr = [];
				let havecheck = [];
				this.serArr = [];
				this.api.signLogs({},id).then(res => {
					res.data.map(r => {
						if(r.is_leave){
							leaveArr.push(r.date.split('-').join('/'))
							this.serArr.push(new Date(r.date.split('-').join('/')).getTime())
						}
						if(r.is_sign){
							havecheck.push(r.date.split('-').join('/'))
							this.serArr.push(new Date(r.date.split('-').join('/')).getTime())
						}
					})
					this.leave = leaveArr;
					this.havecheck = havecheck;
					// console.log(this.serArr)
					//项目日期
					this.planList(id);
				})
			},
			//项目日期
			planList(id){
				let protime = [];
				let unArr = [];
				let date = new Date()
				let nowStr = new Date(date.getFullYear() + '/' + (date.getMonth() + 1) + '/' +date.getDate()).getTime();
				// console.log(nowStr)
				this.api.planList({},id).then(res => {
					res.data.map(r => {
						let day = r.days ? JSON.parse(r.days) : []
						let ym = r.month.substr(0,4)+'/'+Number(r.month.substr(4,2))+'/';
						day.map(d => {
							let str = new Date(ym+d).getTime();
							if(this.serArr.indexOf(str) < 0 && str < nowStr){
								//未签到
								unArr.push(ym+d)
							}else if(this.serArr.indexOf(str) < 0 && str >= nowStr){
								//待签到
								protime.push(ym+d)
							}
						})
					})
					this.checking = protime;
					this.unCheck = unArr;
				})
			},
			sign(t) {
				let url = t == 0 ? 'sign' : t == 1 ? 'userLeaveList' : t == 2 ? 'attlist' : 'scoreList';
				if (t == 3) {
					this.$router.push({
						path: '/userScoreList'
					});
					return
				}
				if (this.list.length == 0) {
					this.Toast('暂无项目')
				} else if (this.list.length == 1) {
					this.$router.push({
						path: '/' + url,
						query: {
							id: this.list[0].id
						}
					});
				} else {
					this.$router.push({
						path: '/choosePro',
						query: {
							t: t
						}
					});
				}
			}
		},
		created() {
			document.title = "个人中心";
			if (!localStorage.getItem('token')) {
				this.$router.push('/login')
				return
			}
			this.user = JSON.parse(localStorage.getItem('user'))
			this.getMsg()
			this.getList();
			
		}
	}
</script>
<style scoped="scoped">
	.top {
		height: 120px;
	}

	.qd {
		width: 100px;
		height: 50px;
		border-radius: 30px 0 0 30px;
		text-align: center;
		line-height: 50px;
		position: absolute;
		right: 0;
	}

	.circle {
		width: 10px;
		height: 10px;
		border-radius: 50%;
		display: inline-block;
		margin-right: 5px;
	}
</style>
